import React from 'react';
import Helmet from 'react-helmet';

interface HelmetHeadProps {
  title: string;
  url: string;
}

const HelmetHead: React.FC<HelmetHeadProps> = ({
  title,
  url,
}: HelmetHeadProps): JSX.Element => {
  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={url} />
      <meta name="description" content="At distriqt, we specialise in development services for all modern technologies for web, mobile, server, and cloud-based platforms. From interactive websites, mobile applications and back-end server systems, we provide innovative, professional and modern solutions for any digital challenge." />
      <meta name="author" content="" />
      <meta
        name="keywords"
        content="digital, mobile, web, app, development, consulting, australia, ane, native extensions, adobe, air, ios, android, mobile, adobeair, flash, actionscript"
      />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta property="og:url" content="https://distriqt.com" />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="distriqt - digital development and consulting"
      />
      <meta property="og:image" content="https://distriqt.com/distriqt-og.jpg" />
      <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="/android-icon-192x192.png"
      />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/manifest.json" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />
      <link rel="icon" href="favicon.ico" type="image/x-icon" />
      <link rel="shortcut icon" href="favicon.ico" type="image/x-icon" />
    </Helmet>
  );
};

export default HelmetHead;
